<template>
<div class="chapter">
<div class="inner_page">
<blockquote>
<blockquote>
<p class="noind" id="epigraph"><a id="start">You can’t run away from true love, Debbie. Just like you can’t run away from God or your country or your family. It’s a part of you, and you’re a part of it. That’s why you and me, aw heck, we’ve just gotta get married when we grow up. We’ll have a mess of kids together. We’ll get old and gray together. It’ll be really neat. You’ll see.</a></p><a id="start">
<blockquote>
<p class="noind" style="margin-top:20px;">—Badger Hayes to Debbie Dale in <i>Badger Hayes, All-American Boy</i>, a film by Matthew Wax</p>
</blockquote>
</a></blockquote><a id="start">
</a></blockquote><a id="start">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5-start.vue?bea0e4d8